$(function initProviderLogos() {
	$.fn.providerLogo = function (data) {
		/**
		 * Effectively duplicates logic defined in ProviderLogo.cs.
		 */
		function makeLogoAttrs(logoEntityIdentifier) {
			const entity = logoEntityIdentifier;

			const configs = window.logos.displayModeConfigs
				.map((mc) => Object.assign({}, mc, {
					imageUrl: window.logos.makeUrl(entity.type, mc.mode, entity.id, entity.fileVersion)
				}))
				.sort((a, b) => a.width - b.width);

			const sizes = configs.map((c) => c.sizeSpecifier).join(", ");

			const srcset = configs.map((c, i) =>
				i + 1 === configs.length
				? c.imageUrl
				: c.imageUrl + " " + c.width + "w").join(", ");

			return {
				alt: "Logo for " + entity.name,
				srcset: srcset,
				sizes: sizes,
				src: configs[0].imageUrl
			};
		}

		return $(this).each(function () {
			const $this = $(this);

			const logoData = data || $this.data("logo");
			const attrs = makeLogoAttrs(logoData);

			$this.attr(attrs);

			const includeLink = ($this.data("include-logo-link") || "").match(/true/i);

			if (includeLink && logoData.linkUrl) {				
				$this.wrap(`<a class="provider-logo-link" href="${logoData.linkUrl}"></a>`);
			}
		});
	};

	window.loadLogos = () =>
		$(".provider-logo.provider-logo-unloaded")
			.providerLogo()
			.removeClass("provider-logo-unloaded");

	$(window.loadLogos);

	if (window.ko) {
		ko.bindingHandlers.providerLogo = {
			update: (el, valueAccessor) => {
				const args = valueAccessor();

				$(el).providerLogo(args);
			}
		};
	}
});
